/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';
export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'about',
    path: '/about',
    component: 'layout.base',
    meta: {
      title: 'about',
      i18nKey: 'route.about'
    },
    children: [
      {
        name: 'about_daxing',
        path: '/about/daxing',
        component: 'view.about_daxing',
        meta: {
          title: 'about_daxing',
          i18nKey: 'route.about_daxing'
        }
      },
      {
        name: 'about_video',
        path: '/about/video',
        component: 'view.about_video',
        meta: {
          title: 'about_video',
          i18nKey: 'route.about_video'
        }
      }
    ]
  },
  {
    name: 'advertising',
    path: '/advertising',
    component: 'layout.base',
    meta: {
      title: 'advertising',
      i18nKey: 'route.advertising',
      icon: 'carbon:cloud-service-management',
      order: 9,
      roles: ['R_ADMIN']
    },
    children: [
      {
        name: 'advertising_amanage',
        path: '/advertising/amanage',
        component: 'view.advertising_amanage',
        meta: {
          title: 'advertising_amanage',
          i18nKey: 'route.advertising_amanage'
        }
      },
      {
        name: 'advertising_gmanage',
        path: '/advertising/gmanage',
        component: 'view.advertising_gmanage',
        meta: {
          title: 'advertising_gmanage',
          i18nKey: 'route.advertising_gmanage'
        }
      }
    ]
  },
  {
    name: 'aiknowledge',
    path: '/aiknowledge',
    component: 'layout.base$view.aiknowledge',
    meta: {
      title: 'aiknowledge',
      i18nKey: 'route.aiknowledge'
    }
  },
  {
    name: 'aiknowledgenew',
    path: '/aiknowledgenew',
    component: 'layout.base',
    meta: {
      title: 'aiknowledgenew',
      i18nKey: 'route.aiknowledgenew'
    },
    children: [
      {
        name: 'aiknowledgenew_chat',
        path: '/aiknowledgenew/chat',
        component: 'view.aiknowledgenew_chat',
        meta: {
          title: 'aiknowledgenew_chat',
          i18nKey: 'route.aiknowledgenew_chat'
        }
      },
      {
        name: 'aiknowledgenew_doc',
        path: '/aiknowledgenew/doc',
        component: 'view.aiknowledgenew_doc',
        meta: {
          title: 'aiknowledgenew_doc',
          i18nKey: 'route.aiknowledgenew_doc'
        }
      },
      {
        name: 'aiknowledgenew_index',
        path: '/aiknowledgenew/index',
        component: 'view.aiknowledgenew_index',
        meta: {
          title: 'aiknowledgenew_index',
          i18nKey: 'route.aiknowledgenew_index'
        }
      }
    ]
  },
  {
    name: 'aitraining',
    path: '/aitraining',
    component: 'layout.base$view.aitraining',
    meta: {
      title: 'aitraining',
      i18nKey: 'route.aitraining'
    }
  },
  {
    name: 'company',
    path: '/company',
    component: 'layout.base$view.company',
    meta: {
      title: 'company',
      i18nKey: 'route.company'
    }
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home',
      icon: 'mdi:monitor-dashboard',
      order: 1
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      constant: true,
      hideInMenu: true,
      keepAlive: true
    }
  },
  {
    name: 'invest',
    path: '/invest',
    component: 'layout.base$view.invest',
    meta: {
      title: 'invest',
      i18nKey: 'route.invest'
    }
  },
  {
    name: 'investment-operation',
    path: '/investment-operation',
    component: 'layout.base$view.investment-operation',
    meta: {
      title: 'investment-operation',
      i18nKey: 'route.investment-operation'
    }
  },
  {
    name: 'investment-operation-data',
    path: '/investment-operation-data',
    component: 'layout.base$view.investment-operation-data',
    meta: {
      title: 'investment-operation-data',
      i18nKey: 'route.investment-operation-data',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'manage',
    path: '/manage',
    component: 'layout.base',
    meta: {
      title: 'manage',
      i18nKey: 'route.manage',
      icon: 'carbon:cloud-service-management',
      order: 9,
      roles: ['R_ADMIN']
    },
    children: [
      {
        name: 'manage_cache-list',
        path: '/manage/cache-list',
        component: 'view.manage_cache-list',
        meta: {
          title: 'manage_cache-list',
          i18nKey: 'route.manage_cache-list',
          icon: 'mdi:database-search',
          order: 11,
          roles: ['R_ADMIN']
        }
      },
      {
        name: 'manage_cache-monitor',
        path: '/manage/cache-monitor',
        component: 'view.manage_cache-monitor',
        meta: {
          title: 'manage_cache-monitor',
          i18nKey: 'route.manage_cache-monitor',
          icon: 'mdi:monitor-dashboard',
          order: 10,
          roles: ['R_ADMIN']
        }
      },
      {
        name: 'manage_config',
        path: '/manage/config',
        component: 'view.manage_config',
        meta: {
          title: 'manage_config',
          i18nKey: 'route.manage_config'
        }
      },
      {
        name: 'manage_dept',
        path: '/manage/dept',
        component: 'view.manage_dept',
        meta: {
          title: 'manage_dept',
          i18nKey: 'route.manage_dept'
        }
      },
      {
        name: 'manage_dict',
        path: '/manage/dict',
        component: 'view.manage_dict',
        meta: {
          title: 'manage_dict',
          i18nKey: 'route.manage_dict'
        }
      },
      {
        name: 'manage_file-manage',
        path: '/manage/file-manage',
        component: 'view.manage_file-manage',
        meta: {
          title: 'manage_file-manage',
          i18nKey: 'route.manage_file-manage'
        }
      },
      {
        name: 'manage_login-log',
        path: '/manage/login-log',
        component: 'view.manage_login-log',
        meta: {
          title: 'manage_login-log',
          i18nKey: 'route.manage_login-log'
        }
      },
      {
        name: 'manage_menu',
        path: '/manage/menu',
        component: 'view.manage_menu',
        meta: {
          title: 'manage_menu',
          i18nKey: 'route.manage_menu',
          icon: 'material-symbols:route',
          order: 3,
          roles: ['R_ADMIN'],
          keepAlive: true
        }
      },
      {
        name: 'manage_operation-log',
        path: '/manage/operation-log',
        component: 'view.manage_operation-log',
        meta: {
          title: 'manage_operation-log',
          i18nKey: 'route.manage_operation-log'
        }
      },
      {
        name: 'manage_oss-config',
        path: '/manage/oss-config',
        component: 'view.manage_oss-config',
        meta: {
          title: 'manage_oss-config',
          i18nKey: 'route.manage_oss-config'
        }
      },
      {
        name: 'manage_post',
        path: '/manage/post',
        component: 'view.manage_post',
        meta: {
          title: 'manage_post',
          i18nKey: 'route.manage_post'
        }
      },
      {
        name: 'manage_role',
        path: '/manage/role',
        component: 'view.manage_role',
        meta: {
          title: 'manage_role',
          i18nKey: 'route.manage_role',
          icon: 'carbon:user-role',
          order: 2,
          roles: ['R_SUPER']
        }
      },
      {
        name: 'manage_system-monitor',
        path: '/manage/system-monitor',
        component: 'view.manage_system-monitor',
        meta: {
          title: 'manage_system-monitor',
          i18nKey: 'route.manage_system-monitor'
        }
      },
      {
        name: 'manage_user',
        path: '/manage/user',
        component: 'view.manage_user',
        meta: {
          title: 'manage_user',
          i18nKey: 'route.manage_user',
          icon: 'ic:round-manage-accounts',
          order: 1,
          roles: ['R_ADMIN']
        }
      },
      {
        name: 'manage_user-detail',
        path: '/manage/user-detail/:id',
        component: 'view.manage_user-detail',
        props: true,
        meta: {
          title: 'manage_user-detail',
          i18nKey: 'route.manage_user-detail',
          hideInMenu: true,
          roles: ['R_ADMIN'],
          activeMenu: 'manage_user'
        }
      }
    ]
  },
  {
    name: 'parkmanage',
    path: '/parkmanage',
    component: 'layout.base$view.parkmanage',
    meta: {
      title: 'parkmanage',
      i18nKey: 'route.parkmanage',
      icon: 'mdi:monitor-dashboard',
      hideInMenu: false,
      order: 2
    }
  },
  {
    name: 'policy',
    path: '/policy',
    component: 'layout.base$view.policy',
    meta: {
      title: 'policy',
      i18nKey: 'route.policy',
      icon: 'mdi:monitor-dashboard',
      order: 2
    }
  },
  {
    name: 'product',
    path: '/product',
    component: 'layout.base$view.product',
    meta: {
      title: 'product',
      i18nKey: 'route.product'
    }
  },
  {
    name: 'project',
    path: '/project',
    component: 'layout.base$view.project',
    meta: {
      title: 'project',
      i18nKey: 'route.project'
    }
  },
  {
    name: 'projectcatalog',
    path: '/projectcatalog',
    component: 'layout.base$view.projectcatalog',
    meta: {
      title: 'projectcatalog',
      i18nKey: 'route.projectcatalog'
    }
  },
  {
    name: 'retained',
    path: '/retained',
    component: 'layout.base',
    meta: {
      title: 'retained',
      i18nKey: 'route.manage',
      icon: 'carbon:cloud-service-management',
      order: 9
    },
    children: [
      {
        name: 'retained_appeal',
        path: '/retained/appeal',
        component: 'view.retained_appeal',
        meta: {
          title: 'retained_appeal',
          i18nKey: 'route.retained_appeal'
        }
      },
      {
        name: 'retained_entry',
        path: '/retained/entry',
        component: 'view.retained_entry',
        meta: {
          title: 'retained_entry',
          i18nKey: 'route.retained_entry'
        }
      },
      {
        name: 'retained_purpose',
        path: '/retained/purpose',
        component: 'view.retained_purpose',
        meta: {
          title: 'retained_purpose',
          i18nKey: 'route.retained_purpose'
        }
      },
      {
        name: 'retained_report',
        path: '/retained/report',
        component: 'view.retained_report',
        meta: {
          title: 'retained_report',
          i18nKey: 'route.retained_report'
        }
      }
    ]
  },
  {
    name: 'user-center',
    path: '/user-center',
    component: 'layout.base$view.user-center',
    meta: {
      title: 'user-center',
      i18nKey: 'route.user-center',
      hideInMenu: true
    }
  }
];
